import React from 'react'
import { Navigate } from 'react-router-dom'
import { UserAuth } from '../context/AuthContext'



const ProtectedPluginFailed = ({children}) => {
    const {user} = UserAuth()

    if(!user){
        return <Navigate to ='/aurora/create/1' />
    }

  return children
}

export default ProtectedPluginFailed